import { useUserApi } from "../api/UserApiClient";
import { UserFrontendService } from "../services/UserFrontendService";

export const useUserService = (): UserFrontendService =>
  new UserFrontendService(useUserApi());
